export default __webpack_public_path__ + "static/media/10000-gift-voucher.13059f29.svg";